// extracted by mini-css-extract-plugin
module.exports = {"card":"z_c"};